import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountViewModel } from 'projects/Administration/src/app/business-entities/account-view-model';
import { AccountService } from 'projects/Administration/src/app/business-services/account.service';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.css']
})
export class AccountDetailsComponent implements OnInit {

  accountId: string;
  accountDetail: AccountViewModel;
  // accountObject: AccountViewModel;
  accountResponse:  AccountViewModel;

  constructor(private accountService: AccountService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.accountId = this.accountService.customerId;
    this.getAccountDetails(this.accountId);
  }

  async getAccountDetails(id) {
    this.spinner.show();
    await this.accountService.getAccountDetailsById(id).then((response) => {

      this.accountResponse = response;
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }

  mapAccountDetails(account: any): AccountViewModel {
    let accountObject: AccountViewModel;
    accountObject.accountName = account.customerName;
    accountObject.accountNo = account.customerNo;
    accountObject.addressLine1 = account.addressLine1;
    accountObject.addressLine2 = account.addressLine2;
    accountObject.city = account.city;
    accountObject.state = account.state;
    accountObject.country = account.country;
    accountObject.email = account.email;
    accountObject.mobileNo = account.mobileNo;
    accountObject.pincode = account.pincode;

    return accountObject;
  }

}
